import { 
  Home, 
  LayoutDashboard, 
  BarChart2, 
  Archive, 
  Calculator, 
  Target, 
  Zap, 
  CheckCircle, 
  Sheet, 
  Brain, 
  BookOpen,
  LucideIcon
} from 'lucide-react';

export interface NavigationItem {
  id: string;
  label: string;
  path: string;
  icon: LucideIcon;
  requiresAuth?: boolean;
  external?: boolean;
  description?: string;
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    id: 'home',
    label: 'Home',
    path: '/',
    icon: Home,
    description: 'Return to homepage'
  },
  {
    id: 'dashboard',
    label: 'Dashboard',
    path: '/dashboard',
    icon: LayoutDashboard,
    requiresAuth: true,
    description: 'Your personal career command center'
  },
  {
    id: 'loaded-score',
    label: 'Loaded Score',
    path: '/score',
    icon: BarChart2,
    description: 'Career assessment and scoring'
  },
  {
    id: 'career-artifacts',
    label: 'Career Artifacts',
    path: '/artifacts',
    icon: Archive,
    description: 'Career planning tools and documents'
  },
  {
    id: 'rate-whisperer',
    label: 'Rate Whisperer',
    path: '/rate-whisperer',
    icon: Calculator,
    description: 'Calculate your ideal consulting rates'
  },
  {
    id: 'opportunity-audit',
    label: 'Opportunity Audit',
    path: '/opportunity-audit',
    icon: Target,
    description: 'Evaluate career opportunities'
  },
  {
    id: 'power-moves',
    label: 'Power Moves',
    path: '/power-moves',
    icon: Zap,
    description: 'Strategic career action planning'
  },
  {
    id: 'okrs',
    label: 'OKRs',
    path: '/okrs',
    icon: CheckCircle,
    description: 'Objectives and key results tracking'
  },
  {
    id: 'big-sheet',
    label: 'Big Sheet',
    path: '/big-sheet',
    icon: Sheet,
    description: 'Comprehensive career planning canvas'
  },
  {
    id: 'ai-workspace',
    label: 'AI Assistants',
    path: '/workspace',
    icon: Brain,
    description: 'AI-powered career guidance'
  },
  {
    id: 'masterclass',
    label: 'Masterclass',
    path: 'https://maven.com/productdioxide/loaded-career',
    icon: BookOpen,
    external: true,
    description: 'Learn from career experts'
  }
];

// Helper functions for filtering navigation items
export const getNavigationItems = (session?: boolean | null) => {
  return NAVIGATION_ITEMS.filter(item => !item.requiresAuth || session);
};

export const getMainNavigationItems = (session?: boolean | null) => {
  // Core navigation items for main menu - show more items on desktop
  const coreItems = ['loaded-score', 'career-artifacts', 'rate-whisperer', 'ai-workspace'];
  if (session) {
    coreItems.unshift('dashboard'); // Add dashboard at the beginning if authenticated
  }
  
  return NAVIGATION_ITEMS.filter(item => 
    coreItems.includes(item.id) && (!item.requiresAuth || session)
  );
};

export const getToolsNavigationItems = () => {
  const toolItems = ['opportunity-audit', 'power-moves', 'okrs', 'big-sheet'];
  return NAVIGATION_ITEMS.filter(item => toolItems.includes(item.id));
};

export const getLearningNavigationItems = () => {
  const learningItems = ['masterclass'];
  return NAVIGATION_ITEMS.filter(item => learningItems.includes(item.id));
};